import { combineReducers } from 'redux';

import genericLoadingReducer from 'modules/global/reducers/generic.loading';
import * as types from 'modules/questionModels/actionTypes';

import ids from './ids';
import isDuplicating from './isDuplicating';
import page from './page';

/**
 * @typedef {{
 *  ids: string[],
 *  page: import('modules/global/generic.types').Page,
 *  isDuplicating: boolean,
 * }} QuestionModelsUIDashboardReducer
 */

export default combineReducers({
  ids,
  page,
  isDuplicating,
  isFetching: genericLoadingReducer(types.FETCH_QUESTION_MODELS),
});
